import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#1976d2",
        },
        secondary: {
          main: "#00C4A7",
        },
        error: {
          main: "#E74C3C",
        },
        success: {
          main: "#00C4A7",
          contrastText: "#FFFFFF",
        },
      },
    },
  },
});
